
import api from '../../api'

import {
    CREATE_NEW_AD_COMPARABLE,
    DELETE_AD_COMPARABLE,
    RESET_AD_COMPARABLE,
    SET_AD_COMPARABLE,
    SET_AD_COMPARABLE_ID,
    SET_AD_COMPARABLE_DATE_CREATED,
    SET_AD_COMPARABLE_DATE_MODIFIED,
    SET_AD_COMPARABLE_DIRTYNESS,
    SET_AD_COMPARABLE_PARENT_PATH,
    SET_AD_COMPARABLE_PATH,
    UPDATE_AD_COMPARABLE,
    SET_AD_COMPARABLE_DESCRIPTION,


} from '../../constants'

const default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    description: null
}

const state = default_state

const actions = {

    CREATE_NEW_AD_COMPARABLE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.create({key: data.key, path: data.path})
                .then((res) => {
                    const new_created_key = res.key
                    
                    commit(SET_AD_COMPARABLE_ID, new_created_key)
                    commit(SET_AD_COMPARABLE_DATE_CREATED, res.date_created)
                    commit(SET_AD_COMPARABLE_DATE_MODIFIED, res.date_modified)
                    commit(SET_AD_COMPARABLE_PARENT_PATH, data.parent_path)
                    commit(SET_AD_COMPARABLE_PATH, res.path)

                    let comp_obj = data.ad
                    comp_obj['ad_id'] = comp_obj['id']
                    comp_obj['id'] = new_created_key
                    comp_obj['date_created'] = res.date_created
                    comp_obj['date_modified'] = res.date_modified
                    comp_obj['parent_path'] = data.parent_path
                    comp_obj['path'] = res.path

                    api.set_value({
                        value: comp_obj,
                        path: data.path + new_created_key + '/',
                        save_timestamp: false
                    }).then((res) => {
                            const object = {}
                            object[new_created_key] = true
                            api.update({
                                object: object,
                                path: data.parent_path,
                                save_timestamp: false
                            }).then(res => resolve({key: new_created_key}))
                        })
                })

        })
    },
    DELETE_AD_COMPARABLE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {

            // delete from path
            api.delete({key: data.key, path: data.path})
                .then((res) => {
                    // delete from parent_path
                    api.delete({key: data.key, path: data.parent_path})
                        .then((res) => {
                            commit(RESET_AD_COMPARABLE)

                        }).then(res => resolve({}))
                })

        })

    },
    SET_AD_COMPARABLE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            return api.get({path: data.path})
                .then((res) => {
                    // console.log(res)
                    commit(SET_AD_COMPARABLE, res)
                }).then(res => resolve({}))

        })

    },
    RESET_AD_COMPARABLE: ({state, commit, rootState}) => {
        commit(RESET_AD_COMPARABLE)
    },
    SET_AD_COMPARABLE_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_AD_COMPARABLE_DATE_CREATED, data)
    },
    SET_AD_COMPARABLE_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_AD_COMPARABLE_DATE_MODIFIED, data)
    },

    SET_AD_COMPARABLE_ID: ({state, commit, rootState}, data) => {
        commit(SET_AD_COMPARABLE_ID, data)
    },
    SET_AD_COMPARABLE_PARENT_PATH: ({state, commit, rootState}, data) => {
        commit(SET_AD_COMPARABLE_PARENT_PATH, data)
    },
    SET_AD_COMPARABLE_PATH: ({state, commit, rootState}, data) => {
        commit(SET_AD_COMPARABLE_PATH, data)
    },
    UPDATE_AD_COMPARABLE: ({state, commit, rootState}, data) => {
        api.update({object: data.object, path: data.path, save_timestamp: true})
            .then((res) => {

                commit(SET_AD_COMPARABLE_DATE_MODIFIED, res.date_modified)
                commit(SET_AD_COMPARABLE_DIRTYNESS, false)
            })
    },
    SET_AD_COMPARABLE_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_AD_COMPARABLE_DESCRIPTION, data)
    }
}

const mutations = {

    [RESET_AD_COMPARABLE] (state) {
        //general data
        state.date_created = null
        state.date_modified = null
        state.dirty = false
        state.id = null
        state.parent_path = null
        state.path = null

        //particular data
        state.description = null

    },
    [SET_AD_COMPARABLE] (state, data) {
        //general data
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.dirty = false
        state.id = check_undefined(data.id)
        state.parent_path = check_undefined(data.parent_path)
        state.path = check_undefined(data.path)

        //particular data
        state.description = check_undefined(data.description)
   


    },
    [SET_AD_COMPARABLE_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_AD_COMPARABLE_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_AD_COMPARABLE_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_AD_COMPARABLE_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_AD_COMPARABLE_PARENT_PATH] (state, data) {
        state.parent_path = data
        state.dirty = true
    },
    [SET_AD_COMPARABLE_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_AD_COMPARABLE_DESCRIPTION] (state, data) {
        state.description = data
        state.dirty = true
    }
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

const getters = {

    ad_comparable: state => {
        return state
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/ad_comparable/ad_comparable.js